"use client";

import { SessionProvider } from "next-auth/react";
import { Wrapper } from "@/components/wrapper";
import { FormProvider } from "./FormContext";
import { ProfileImageProvider } from "./ProfileImageContext";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <ProfileImageProvider>
        <Wrapper>
          <FormProvider>{children}</FormProvider>
        </Wrapper>
      </ProfileImageProvider>
    </SessionProvider>
  );
}